import sc, {keyframes} from 'styled-components';

const indeterminate1 = keyframes`
    0% {
        left: -35%;
        right: 100%;
    }
    60% {
        left: 100%;
        right: -90%;
    }
    100% {
        left: 100%;
        right: -90%;
    }
`;

const indeterminate2 = keyframes`
    0% {
        left: -200%;
        right: 100%;
    }
    60% {
        left: 107%;
        right: -8%;
    }
    100% {
        left: 107%;
        right: -8%;
    }
`;

const circleOne = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(-720deg);
    }
`;

const circleTwo = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const load = keyframes`
    0% {
        width: 0%;
    }
    50% {
        width: 100%;
    }
    100% {
        width: 0%;
    }
`;

// Circular loader

export const StyledCircularLoaderWrapper = sc.div`
    position: relative;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const styledCircles = sc.div`
    box-sizing: border-box;
    position: absolute;
    display: block;
    margin: auto;
    border: 3px solid transparent;
    border-radius: 50%;
`;

export const StyledCircle1 = sc(styledCircles)`
    width: 42px;
    height: 42px;
    border-bottom: 3px solid #001b74;
    border-left: 3px solid #001b74;
    animation: ${circleOne} 1.6s linear infinite;
    border-radius: 50%;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;
`;

export const StyledCircle2 = sc(styledCircles)`
    width: 32px;
    height: 32px;
    border-top: 3px solid #003599;
    border-left: 3px solid #003599;
    animation: ${circleTwo} 1s linear infinite;
    border-radius: 50%;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;
`;

// Linear loader

export const StyledLinearLoaderProgress = sc.div<{$big?: boolean}>`
    position: absolute;
    top: 0;
    height: ${({$big}) => $big ? '10px' : '10px'};
    background: #001b74;
    animation: ${load} 6s linear infinite alternate;
    left: 0;
`;

export const StyledLinearLoaderWrapper = sc.div<{$size?: number | undefined; $big?: boolean}>`
    position: relative;
    width: ${({$size}) => ($size ? `${$size}px` : '100%')};
    height: ${({$big}) => ($big ? '10px' : '4px')};
    background: rgba(0, 27, 116, 0.1);
    overflow: hidden;
`;

export const StyledLinearLoaderBar = sc.div<{$big?: boolean}>`
    position: absolute;
    height: ${({$big}) => ($big ? '10px' : '4px')};
    background: linear-gradient(90deg, #4274d16a 0%, #001b74 100%);
    will-change: left, right;
`;

export const StyledLinearLoaderBar1 = sc(StyledLinearLoaderBar)`
    animation: ${indeterminate1} 1.5s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
`;

export const StyledLinearLoaderBar2 = sc(StyledLinearLoaderBar)`
    animation: ${indeterminate2} 1.5s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
`;

